import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';

/**
 * Tipo de impressao suportado pelo backend Jasper para o pedido.
 *
 * Alinhado com o enum `TipoImpressao` do backend (A4 | BOBINA_58 | BOBINA_80),
 * exposto como string literal no FE para espelhar o padrao ja usado pelo
 * `tipoDeImpressaoForm` da fatura-view (sem criar enum formal).
 */
export type FormatoImpressao = 'A4' | 'BOBINA_58' | 'BOBINA_80';

/**
 * Service isolado para geracao do PDF do pedido (Jasper).
 *
 * Padrao obrigatorio (CLAUDE.md): Page -> Service -> ApiService -> Backend.
 * HttpClient direto NAO e permitido neste service.
 *
 * O backend retorna o PDF como Base64 em `text/plain` (mesmo padrao consolidado
 * do `NotaService.gerarPdfNota`). A conversao Base64 -> Blob('application/pdf')
 * e responsabilidade do componente que consome o retorno.
 */
@Injectable({ providedIn: 'root' })
export class ImpressaoPedidoService {
  constructor(private apiService: ApiService) {}

  /**
   * POST /pedidos/gerar-pdf/{id}/impressao/{impressao}
   *
   * @param id identificador do pedido
   * @param impressao formato de impressao (A4, BOBINA_58 ou BOBINA_80)
   * @returns Observable com o PDF em Base64 (string, `text/plain`)
   */
  gerarPdfDePedido(id: number, impressao: FormatoImpressao): Observable<string> {
    const url = `/pedidos/gerar-pdf/${id}/impressao/${impressao}`;
    return this.apiService.postText(url);
  }
}
